// Imports
// React and React Router
import React from 'react';
import { Link } from 'react-router-dom';

// Component Definition
export const TunedCircuitLogo: React.FC<{ className?: string }> = ({ className = '' }) => (
  <Link to="/" className={`flex flex-col items-center ${className}`}>
    <h1 className="bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-3xl font-extrabold text-transparent">
      TunedCircuit
    </h1>
    <div className="mt-2 h-1 w-72 rounded-full bg-gradient-to-r from-pink-500 to-purple-600" />
  </Link>
);
